import React from 'react'
import { ButtonSecondary } from '../../../../components/atoms'
import PropertyGrid from '../../../../components/PropertyGrid'
import { Contact } from '../store/store'
import { useTranslation } from 'react-i18next'
import { RequestState } from '../../../types'
import slugify from 'react-slugify'

type Props = {
  contact: Contact
  removeContact: (contactId: string) => void
  onEdit: (contact: Contact) => void
}

function ContactRowCompact(props: Props) {
  const { contact, removeContact, onEdit } = props
  const { t } = useTranslation(['global', 'settings_contacts', 'form'])

  const deleteButtonText = contact.deleteRequestState === RequestState.Loading
    ? t('global:deleting')
    : t('global:delete')

  return (
    <>
      <div className="header-cell flex-justify-start">
        {contact.name}
      </div>
      <div className="padding-s" data-cy={`compact-${slugify(contact.name)}`}>
        <PropertyGrid
          data-cy={slugify(contact.name)}
          properties={{
            [t('form:email')]: contact.email,
            [t('form:mobile')]: contact.mobile,
            [t('form:phone')]: contact.phone,
            [t('global:actions')]: (
              <div className="flex-row">
                <ButtonSecondary 
                  data-cy="edit"
                  onClick={() => onEdit(contact)}>
                  {t('global:edit')}
                </ButtonSecondary>
                <ButtonSecondary
                  className="delete-btn"
                  data-cy="delete"
                  onClick={() => removeContact(contact.id)}
                  disabled={contact.deleteRequestState === RequestState.Loading}>
                  {deleteButtonText}
                </ButtonSecondary>
              </div>
            )
          }}
        />
      </div>
    </>
  )
}

export default ContactRowCompact
